// layouts/DefaultLayout.jsx
import { useRef, useState } from "react";
import Sidebar from "@components/ui/Sidebar";
import Navbar from "@components/ui/Navbar";

import MedicalViewModal from "@components/common/Modals/MedicalViewModal";
import { Link, useLocation } from "react-router-dom";
import ScrollToTop from "@components/common/ScrollToTop";
import CreatePlansModal from "@components/common/CreatePlansModal";
import { ReactComponent as WarningInfoIcon } from "@assets/images/warningInfoIcon.svg";
import stepBack from "@assets/images/stepsBack.jpg";
import { useTranslation } from "react-i18next";
import { useUserData } from "context/OAuth/AuthContext";
import { WeeklyCheckInModal } from "@components/common/WeeklyCheckIn";
import GoogleFirstPopup from "@components/common/Modals/GoogleFirstPopup";
import WelcomePopup from "@components/common/Modals/WelcomePopup";

const URL_TO_NAVIGATE = process.env.REACT_APP_WORDPRESS_URL;

const DefaultLayout = ({
  children,
}) => {
  const { subscription } = useUserData();
  const userStatus = subscription?.status;
  const subscriptionEndDate = subscription?.next_payment_date
    ? subscription?.next_payment_date
    : subscription?.trial_end;

  const location = useLocation();
  const { t } = useTranslation();
  const { weeklyCheckIn, setWeeklyCheckIn } = useUserData();
  const positionRef = useRef(null);
  const getDate = () => {
    const date1 = new Date();
    const date2 = new Date(subscriptionEndDate);
    const diffInMilliseconds = date2 - date1;

    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    return diffInDays;
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="w-64 h-full fixed top-0 left-0 bg-white hidden lg:block ">
        <Sidebar />
      </div>

      <div className="flex-1 flex flex-col ml-0 lg:ml-64 lg:max-w-[calc(100%-16rem)]">
        <Navbar />
        <div
          className={`flex-1 bg-[#EEEEEE] overflow-y-auto ${
            location.pathname === "/progress-tracker" ||
            location.pathname === "/fitbot-support"
              ? ""
              : "overflow-y-scroll"
          }`}
        >
          <div
            className={`container mx-auto p-4 md:p-8 ${
              location.pathname === "/fitbot-support" && "h-[100%]"
            }`}
            ref={positionRef}
          >
            <ScrollToTop positionRef={positionRef} />
            {/* {(location.pathname.startsWith("/weekly-tracker") ||
              location.pathname.startsWith("/motivational-coach")) && (
              <div
                className="p-5 text-center text-white text-2xl rounded-xl mb-2"
                style={{ backgroundImage: `url(${stepBack})` }}
              >
                🚀 {t("inProgress")}
              </div>
            )} */}
            {userStatus === "pending-cancel" &&
              location?.pathname !== "/renew-subscription" && (
                <div className="border border-[#DFBE00] border-dashed flex justify-between items-center bg-[#FFFFDD] p-2 sm:p-3 md:p-4 rounded-[20px] sm:rounded-[40px] md:rounded-[80px] mb-5">
                  <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 md:gap-4 items-center justify-between w-full">
                    <div className="flex gap-2 items-center justify-center sm:justify-start w-full sm:w-auto">
                      <div className="bg-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <WarningInfoIcon className="w-4 h-4" />
                      </div>
                      <p className="text-[#000] text-[10px] xs:text-[11px] sm:text-[12px] font-[Lato] font-[600] text-center sm:text-left leading-tight">
                        {t("subscription.pendingRenewalMessage", { days: getDate() })}
                      </p>
                    </div>
                    <Link
                      to={`${URL_TO_NAVIGATE}/checkout/`}
                      title="Reactivate Account"
                      className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-3 py-2 sm:px-4 sm:py-2 rounded-full text-[10px] xs:text-[11px] sm:text-[12px] font-medium transition-colors border border-[#E9E9E9] md:border-none whitespace-nowrap flex-shrink-0 w-full sm:w-auto text-center"
                    >
                      {t("renewPayment")}
                    </Link>
                  </div>
                </div>
              )}
            {children}
          </div>
        </div>
      </div>
      {/* <CreatePlansModal
        showModal={showCreatePlan}
        setShowModal={setShowCreatePlan}
        setOpen={setOpen}
      /> */}
      <GoogleFirstPopup />
      <WelcomePopup/>
      <WeeklyCheckInModal open={weeklyCheckIn} setOpen={setWeeklyCheckIn} />
    </div>
  );
};

export default DefaultLayout;
